import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController, PopoverController } from 'ionic-angular';
import { PollProvider } from '../../../providers/poll/poll';
import { NewSondagePage } from './new-sondage/new-sondage';
import { SondageResultsPage } from './sondages-results/sondages-results';


@IonicPage()
@Component({
  selector: 'sondage-employer',
  templateUrl: 'sondage-employer.html',
})
export class SondageEmployerPage {
  historyMode: boolean = false;
  pollListActive: any = [];
  pollListPast: any = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController, public pollProvider: PollProvider, public popoverCtrl: PopoverController) {
    menu.enable(true);
  }

  ionViewDidLoad() {

  }

  loadPolls() {
    this.pollListActive = [];
    this.pollListPast = [];
    this.pollProvider.getAll().subscribe((res) => {
      if (res.success) {
        res.data.forEach(poll => {
          new Date().getTime() > poll.ends_at ? this.pollListActive.push(poll) : this.pollListPast.push(poll)
        });
      }
    })
  }

  newPollModal(){
    let modal = this.modalCtrl.create(NewSondagePage, {
      cssClass: 'my-modal'
    });
    modal.onDidDismiss(() => {
      this.loadPolls();
    });
    modal.present({
      ev: event
    }).then(() => {});
  }

  openPollResult(poll){
    let modal = this.modalCtrl.create(SondageResultsPage, {sondageData: poll});
    modal.onDidDismiss(() => {
      this.loadPolls();
    });
    modal.present({
      ev: event
    }).then(() => {});
  }


  ngOnInit() {
    this.loadPolls()
  }

}





// WEBPACK FOOTER //
// ./src/pages/employer/sondage/sondage-employer.ts